export const theme = {
  primaryDark: "#000000",
  primaryLight: "#FFFFFF",
  primaryHover: "#000000",
  selectorHover: "#FDAD32",
  selection: "#FDAD32",
  hudButtonLight: "#666666",
  hudButtonDark: "#262C35",
  hudButtonFrame: "#253A5C",
  hudButtonHover: "#E070BB",
  hudButtonFrameBg: "#234A5C40",
  hudButtonFrameBgHover: "#E070BB40",
  hudButtonTextLight: "#D9D8D7",
  hudButtonTextDark: "#67696D",
  background: "#121FAA",
  backgroundDark: "#0B1367", // same as buttonDark
  backgroundMenu: "#192CF7",
  backgroundInventory: "#477BFB",
  borderDark: "#0D145F",
  traitBorder: "#4565FF",
  inputBorder: "#1E2CE9",
  buttonDark: "#0B1367",
  buttonLight: "#01C2FF",
  buttonGreen: "#71D595",
  borderGreen: "#5ABF7B",
  pointsGreen: "#19EC8D",
  chromakey: "#0CFF00",
  buttonLightGreen: "#84E1A4",
  buttonDarkGreen: "#3A8055",
  buttonLightBlue: "#708DF7",
  buttonBrightBlue: "#67CFFA",
  frame: "#3B68FB",
  menuTitle: "#1A2CF3",
  lightBlue: "#1C2FF9",
  brightBlue: "#1E2CE9",
  basePurple: "#B94CF6",
  baseOrange: "#F28952",
  baseRed: "#DD5460",
  baseYellow: "#FDAD32",
  baseBlue: "#5ABCEE",
  baseGreen: "#61D398",
  baseViolet: "#9653E6",
  brightYellow: "#FEBF4B",
  borderYellow: "#DB5E04",
  selectionGreen: "#00D693",
  selectionBlue: "#708DF7",
  gray: "#999",
  traitHeight: "62px",
  avatarSize: "96px",
  mobile: "768px",
  iconSize: "24px",
  frameOffset: "24px",
  frameWidth: "3px",
  navHeight: "calc(80px * var(--app-scale))",
  hudPanelWidth: "max(22vw, 333px)",
  hudPanelMaxWidth: "333px",
  selectableButtonSize: "52px",
  smallButtonSize: "32px",
  toggleHandleSize: "24px",
  selectableButtonDecoratorSize: "36px",
  cornerSize: "16px",
  actionIconSize: "16px",
  buttonCornerSize: "8px",
  buttonFrameWidth: "2px",
  promoScrollerHeight: "100px",
  filtersSectionHeight: "240px",
  playbackBarHeight: "112px",
  playbackBarHeightSmaller: "82px",
  qrCodeSize: "256px",
  invNumberSize: "30px",
  assetModalWidth: "450px",
  assetModalPreviewHeight: "195px",
  mintAqua: "#00FFF6",
  mintGreen: "#00FF24",
  mintBackground: "#1F31EF",
  mintDarkblue: "#080344",
  mintYellowHeading: "#FEC115",
  mintTickerBackground: "#606060",
  loseRed: "#F31A30",
  winGreen: "#1AF386",
  mintProgressBarWidthBreakpoint: "1080px",
  minModalScale: 0.85,
};
